// extracted by mini-css-extract-plugin
export var header = "styles-module--header--7eb59";
export var second = "styles-module--second--553b6";